import { OwcTypography } from "@one/react";

import { FormSelect } from "./FormSelect";
import { FormInput } from "./FormInput";
import { ColumnType, DescriptionItem, THEME } from "@digitallab/grid-common-frontend-components";
import { react18WorkaroundProps } from "../../../constants/react18WorkaroundProps";

export const RenderFormColumn = ({ column }: { column: ColumnType }): React.ReactElement | null => {
  const renderers: Record<string, (column: ColumnType) => React.ReactNode> = {
    input: (column) => <FormInput column={column} />,
    selectObject: (column) => <FormSelect column={column} />,
    selectString: (column) => <FormSelect column={column} />,
    description: (column) => (
      <div style={{ minHeight: 60, alignContent: "center" }}>
        <OwcTypography {...react18WorkaroundProps}>{column.defaultValue}</OwcTypography>
      </div>
    ),
    custom: (column) => column.customRender,
    list: (column) => (
      <div style={{ marginBottom: THEME["one-spacer-16"], maxHeight: 330, overflowY: "auto" }}>
        <DescriptionItem
          horizontal
          keyValue={"header"}
          label={
            <div style={{ width: "50%", color: THEME["one-color-gray-600"], paddingLeft: THEME["one-spacer-8"] }}>
              {column.headers?.[0]}
            </div>
          }
          value={
            <div style={{ width: "50%", color: THEME["one-color-gray-600"], paddingLeft: THEME["one-spacer-8"] }}>
              {column.headers?.[1]}
            </div>
          }
          style={{
            height: THEME["one-spacer-40"],
            backgroundColor: THEME["one-color-cobas-gray-100"],
            borderTop: `1px solid ${THEME["one-color-cobas-gray-300"]}`,
            borderBottom: `1px solid ${THEME["one-color-cobas-gray-300"]}`
          }}
        />
        {column.columns?.map((item, index) => (
          <div key={`${item.name}-${index}`}>{inputColumn(item)}</div>
        ))}
      </div>
    )
  };

  const inputColumn = (column: ColumnType) => {
    return renderers[column.type] ? (
      renderers[column.type](column)
    ) : (
      <div style={{ paddingLeft: THEME["one-spacer-16"] }}>Field type not implemented</div>
    );
  };
  const rendered = inputColumn(column);
  return rendered === undefined ? null : (rendered as React.ReactElement);
};

export const RenderFormColumns = ({ columns }: { columns: ColumnType[] }) => {
  return (
    <>
      {columns.map((column, index) => (
        <div key={`${column.name}-${index}`}>
          <RenderFormColumn key={column.name} column={column} />
        </div>
      ))}
    </>
  );
};
